import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:570
* @route '/teacher/settings/documents'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/teacher/settings/documents',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:570
* @route '/teacher/settings/documents'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:570
* @route '/teacher/settings/documents'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

const documents = {
    update: Object.assign(update, update),
}

export default documents